import { convertKeysToCamelCase, convertKeysToSnakeCase } from 'Helpers/caseConversion';
import type {
    ApiInvoicingSettingsMetadata,
    InvoicingSettingsMetadata,
} from 'types/api/settings/invoicing/invoicingSettingsTypes';
import type {
    ApiConditionsAndAcceptancesSettings,
    ConditionsAndAcceptancesSettings,
} from 'types/api/settings/invoicing/invoicingConditionsTypes';
import type { AxiosResponse } from 'axios';

const baseUrl = '/invoicing/settings';

const getMetadata = async (): Promise<InvoicingSettingsMetadata> => {
    const response = await ApiClient.get(`${baseUrl}/metadata`);
    return convertKeysToCamelCase(
        response.data as ApiInvoicingSettingsMetadata,
    ) as InvoicingSettingsMetadata;
};

const getConditionsAndAcceptances = async (): Promise<ConditionsAndAcceptancesSettings> => {
    const response: AxiosResponse<ApiConditionsAndAcceptancesSettings> = await ApiClient.get(
        `${baseUrl}/conditions-and-acceptances`,
    );
    return convertKeysToCamelCase(response.data) as ConditionsAndAcceptancesSettings;
};

const updateConditionsAndAcceptances = async (
    data: ConditionsAndAcceptancesSettings,
): Promise<AxiosResponse> => {
    return ApiClient.patch(
        `${baseUrl}/conditions-and-acceptances`,
        {},
        convertKeysToSnakeCase(data),
    );
};

export { getMetadata, getConditionsAndAcceptances, updateConditionsAndAcceptances };
